@use '../../../../app/styles/common/mixins';

.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--spasing08);
}
